class NotEnoughTicketsLeftError extends Error {
  constructor(tickets) {
    super();
    this.name = "NotEnoughTicketsLeftError";
    this.message = `There are only ${tickets} left`;
  }
}

export default NotEnoughTicketsLeftError;
